<template>
  <div class="my_form">
    <el-form :model="sysUserDtoFilter" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="8" :md="24">
          <el-form-item label="真实姓名:" prop="showName">
              <el-input v-model="sysUserDtoFilter.showName" placeholder="请输入真实姓名"/>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="24" class="action" style="margin-bottom:20px">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
      <el-row type="flex" justify="space-between">
        <el-col :span="5" class="dept">
          <el-tree ref="tree" default-expand-all :data="deptData" node-key="id" :default-checked-keys="key" @node-click="handleNodeClick"></el-tree>
        </el-col>
        <el-col :span="18">
          <STable :columns="columns" :loadData="loadData" ref="table" v-if="deptAll || deptId">
            <template #sn='{ $index }'>
              {{ $index + 1 }}
            </template>
            <template #userStatus="scope">
              <el-tag :type="getUserStatusType(scope.row.userStatus)" :size="defaultFormItemSize">{{SysUserStatus.getValue(scope.row.userStatus)}}</el-tag>
            </template>
            <template #createTime="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </STable>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import { CityProject } from '@/api/datamanagement'
import STable from '@/components/STable';
import { LicenseManagement } from '@/api/Licence'
// import StaticDict from '@/staticDict';
import { SystemController } from '@/api';
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
export default {
  components: {
    STable
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '用户名',
          prop: 'loginName',
          ellipsis: true,
          width: 400
        },
        {
          label: '真实姓名',
          // align: 'center',
          prop: 'showName',
          ellipsis: true,
          width: 350
        },
        {
          label: '账号类型',
          prop: 'userTypeDictMap.name',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '部门',
          prop: 'deptIdDictMap.name',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '状态',
          scopedSlots: 'userStatus',
          // align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          label: '创建时间',
          // align: 'center',
          width: 200,
          scopedSlots:'createTime',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        this.sysUserDtoFilter.deptId = this.deptAll ? this.sysUserDtoFilter.deptId : this.deptId
        const sysUserDtoFilter = this.sysUserDtoFilter
        return LicenseManagement.getPeopleList(this, {sysUserDtoFilter,pageParam}).then(res => res)
      },
      visible: false,
      record: {},
      deptData: [],
      userList:[],
      // StaticDict,
      sysUserDtoFilter:{
        showName : '',
        deptId:''
      },
      key:[],
      deptId:'',
      deptAll:false
    }
  },
  created () {
    this.getDeptAndPeople()
    this.isLeader()
  },
  methods: {
    isLeader(){
      const userInfo = this.getUserInfo
      const deptList = [1,2,6]
      const userList = [117,226]
      if(userList.indexOf(userInfo.userId) > -1 || deptList.indexOf(userInfo.deptId) > -1){
        this.deptAll = true
      }else{  
        SystemController.getUser(this,{userId:userInfo.userId}).then(res => {
          res.data.sysUserPostList.forEach(item => {
            if(item.postId == '1440964097913917440'){
              this.deptAll = true
            }
          })
          if(!this.deptAll){
            this.deptId = userInfo.deptId
            this.$refs.tree.setCurrentKey(userInfo.deptId)
          }
        })
      }
    },
    getDeptAndPeople () {
      LicenseManagement.getDeptList(this, {}).then(res => {
        this.listToTree(res.data.dataList, this.deptData, 0)
      })
    },
    submitForm () {
      if (this.$refs.table) this.$refs.table.refresh()
    },
    resetForm () {
      this.sysUserDtoFilter.showName = ''
      this.$refs.table.refresh(true)
    },
    // list 转 tree 递归
    listToTree (list, tree,index) {
      if(index > 10) return
      if (!index) {
        for (let i = 0; i < list.length; i++) {
         if (!list[i].parentId && list[i].deptId !== '1440911410581213416'){
            tree.push(
              {
                label: list[i].deptName,
                id:list[i].deptId,
                index,
                children: []
              }
            )
            list.splice(i,1)
            i--
          }
        }
      }else{
        if(index === 1){
          const userInfo = this.getUserInfo
          const deptList = [1,2,6]
          const userList = [117,226]
          
          if(userList.indexOf(userInfo.userId) > -1 || deptList.indexOf(userInfo.deptId) > -1){
            for (let i = 0; i < list.length; i++) {
             if (list[i].parentId){
                  if (list[i].parentId === tree.id) {
                    tree.children.push({
                      label: list[i].deptName,
                      id:list[i].deptId,
                      index,
                      children: []
                    })
                    list.splice(i,1)
                    i--
                  }
              }
            }
          } else {
            let deptAll = false
            SystemController.getUser(this,{userId:userInfo.userId}).then(res => {
              res.data.sysUserPostList.forEach(item => {
                if(item.postId == '1440964097913917440'){
                  deptAll = true
                }
              })
              if(!deptAll){
                list = list.filter(data => data.deptId == userInfo.deptId || data.parentId != 1440963733084966913)
              }
              for (let i = 0; i < list.length; i++) {
               if (list[i].parentId){
                    if (list[i].parentId === tree.id) {
                      tree.children.push({
                        label: list[i].deptName,
                        id:list[i].deptId,
                        index,
                        children: []
                      })
                      list.splice(i,1)
                      i--
                    }
                }
              }
            })
          }
        }else{
          for (let i = 0; i < list.length; i++) {
           if (list[i].parentId){
                if (list[i].parentId === tree.id) {
                  tree.children.push({
                    label: list[i].deptName,
                    id:list[i].deptId,
                    index,
                    children: []
                  })
                  list.splice(i,1)
                  i--
                }
            }
          }
        }
      }
      if (list.length) {
        const arr =  Array.isArray(tree) ? tree : tree.children
        arr.forEach(item => {
          this.listToTree(list, item,index + 1)
        })
      }
    },
    getUserStatusType (status) {
      if (status === this.SysUserStatus.NORMAL) {
        return 'success';
      } else if (status === this.SysUserStatus.LOCKED) {
        return 'danger';
      } else {
        return 'info';
      }
    },
    handleNodeClick(val){
      if(this.deptAll){
        this.sysUserDtoFilter.deptId =val.index ? val.id : ''
        if (this.$refs.table) this.$refs.table.refresh()
      }else{
        this.$refs.tree.setCurrentKey(this.deptId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dept{
  height: 70vh;
  min-width: 300px;
  overflow: auto;
}
::v-deep(.el-tree-node__expand-icon){
  background: url('../../assets/icon/tree.png');
  background-size: 100% 100%;
  width: 20px;
  height: 20px;
  margin: 0 10px;
  &.el-icon-caret-right:before{
    display: none;
  }
  &.expanded{
    transform: none;
  }
}

 ::v-deep(.el-tree-node__content){
  height: 50px;
  width: 90%;
 }
  ::v-deep(.el-tree-node__children){
    .el-tree-node__expand-icon{
      background: none;
    }
    .el-icon-caret-right:before{
       display: block ;
       content: '';
       width: 5px;
       height: 5px;
       border-radius: 50%;
       background-color: rgb(89, 89, 89);
       margin: 3px -20px 0 0;
    }
  }
</style>
